/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'expandIcon': {
    width: 300,
    height: 300,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M243.3 495c8.3 14.3 26.7 19.2 41 11L512 374.5 739.7 506c14.3 8.2 32.7 3.3 41-11 8.3-14.3 3.3-32.7-11-41L527.3 314c-4.7-2.7-9.8-4-14.9-4h-.8c-5.1 0-10.2 1.3-14.9 4L254.3 454c-14.3 8.3-19.3 26.7-11 41z" _fill="#B3B3B3"/><path pid="1" d="M769.7 651.6l-242.5-140c-4.7-2.7-9.8-4-14.9-4h-.8c-5.1 0-10.2 1.3-14.9 4l-242.5 140c-14.3 8.2-19.2 26.7-11 41 8.3 14.3 26.7 19.2 41 11L512 572.1l227.7 131.5c14.3 8.2 32.7 3.3 41-11 8.3-14.3 3.3-32.7-11-41z" _fill="#B3B3B3"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/expandIcon.js